module.exports = __webpack_public_path__ + "451284cedf7277f87440e014c3c11557.svg";